import React from 'react';
import { STATE_LABEL, stateTone, fDay } from './labView';

/**
 * LAB-FE-1 — the prototype's `.chip` family for a Test Request: the state chip
 * (`chip.state` / `.done` / `.bad` / `.flag` / `.void`) and the amber
 * "Overdue · required <date>" beside it. The same shapes as HoBits' `Chip`,
 * plus the red one a Fail needs.
 */
const TONE = {
  state: 'bg-sky-300/10 border border-sky-300/30 text-sky-300',
  done: 'bg-emerald-400/10 border border-emerald-400/35 text-emerald-400',
  bad: 'bg-red-400/10 border border-red-400/40 text-red-400',
  flag: 'bg-amber-400/10 border border-amber-400/35 text-amber-400',
  mine: 'bg-orange-500/15 border border-orange-500/50 text-orange-300',
  void: 'bg-transparent border border-slate-700 text-slate-500',
  plain: 'bg-slate-800 text-slate-300',
};

export function TrChip({ tone = 'plain', children, testId }) {
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11.5px] font-bold whitespace-nowrap ${TONE[tone] || TONE.plain}`} data-testid={testId}>
      {children}
    </span>
  );
}

/** The state chip, and the overdue flag when the server says so. */
export function StateChips({ state, overdue, requiredDate, testId }) {
  return (
    <span className="inline-flex flex-wrap gap-1.5 items-center" data-testid={testId}>
      <TrChip tone={stateTone(state)} testId={testId ? `${testId}-state` : undefined}>
        {STATE_LABEL[state] || state || '—'}
      </TrChip>
      {overdue ? (
        <TrChip tone="flag" testId={testId ? `${testId}-overdue` : undefined}>
          {`Overdue — Due ${fDay(requiredDate)}`}
        </TrChip>
      ) : null}
    </span>
  );
}
